import { PARTNER } from "@src/partner"
import { callApi } from "../callApi"

type GET_PARTNER_RESPONSE = PARTNER[]

export const getPartner = async () => {
  return callApi<null, GET_PARTNER_RESPONSE>({ method: "GET", path: "/partner" })
}
